import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Divider from "@material-ui/core/Divider"
import { CollateralStyles } from '../../CollateralStyles'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
import UseForm from '../../../common/UseForm'
import DataTable from 'react-data-table-component'
import { customStyleSecondary } from '../../../common/CommonStyles'
import { Button, Container, TextField, FormControl, Grid, Input, InputLabel, MenuItem, Select } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { Backdrop, CircularProgress } from '@material-ui/core'

const Rigths = ({ classes, ...props }) => {
    const { t } = useTranslation()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const initialSaveSubStageBody = {
        BranchOfficeId: props.match.params.branchOfficeId,
        WOID: props.workDetail[0].woid,
        ProcedureID: "",
        Amount: 0,
        FormFile: {}
    }

    const {
        values,
        handleInputChange,
        handleInpuFileChange,
        resetForm
    } = UseForm(initialSaveSubStageBody)

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Rigths(props.userLanguage, props.userToken, onError, onSuccess)
        props.actions.fetch_Rigths_Per_Order(props.userLanguage, props.userToken, props.workDetail[0].woid, onError, onSuccess)
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmit = e => {
        e.preventDefault()

        let amountInt = parseFloat(values.Amount)
        if (values.pdf !== undefined && amountInt !== undefined && values.ProcedureID !== undefined && amountInt > 0) {
            handleOpenBackdrop()

            const formData = new FormData()
            formData.append('BranchOfficeId', values.BranchOfficeId)
            formData.append('WOID', values.WOID)
            formData.append('ProcedureID', values.ProcedureID)
            formData.append('Amount', amountInt)

            for (let file of values.pdf) {
                formData.append("FormFile", file);
            }

            props.actions.save_Rigths(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
        } else if (typeof (amountInt) === 'string' || typeof (amountInt) === 'undefined') {
            Modal.error({
                title: 'Error',
                content: t('collateralErrors.amountString')
            })
        } else if (amountInt <= 0) {
            Modal.error({
                title: 'Error',
                content: t('collateralErrors.amountGreaterZero')
            })
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const onSuccess = (res) => {
        handleCloseBackdrop()
        if (res.success === false) {

        }
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        props.actions.fetch_Rigths_Per_Order(props.userLanguage, props.userToken, props.workDetail[0].woid, onError, onSuccess)
        if (response.success) {
            Modal.success({
                title: t('commonMessages.deletedSucc')
            })
        } else {
            Modal.error({
                title: 'Error',
                content: response.message
            })
        }
    }

    const onSuccessSave = () => {
        handleCloseBackdrop()
        Modal.success({
            title: t('commonMessages.savedSucc')
        })
        props.actions.fetch_Rigths_Per_Order(props.userLanguage, props.userToken, props.workDetail[0].woid, onError, onSuccess)
        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        )
        resetForm()
    }

    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const handleDelete = (procedureId, procedureDocumentId) => {
        handleOpenBackdrop()
        props.actions.delete_Right(props.userLanguage, props.userToken, procedureId, procedureDocumentId, props.workDetail[0].woid, props.match.params.branchOfficeId, onError, onSuccessDelete)
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: err.response.errors[0]
                    })
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const checkFileType = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf', 'image/png', 'image/jpeg']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const columns = [
        {
            name: t('collateralDetails.rigthsFileName'),
            selector: 'fileName',
            sortable: true,
            with: '300px',
            cell: row => row.fileName
        },
        {
            name: t('collateralDetails.rigthsName'),
            selector: 'description',
            sortable: true,
            with: '350px',
            cell: row => row.description
        },
        {
            name: t('collateralDetails.rigthsDate'),
            selector: 'date',
            width: '200px',
            sortable: true,
            cell: row => row.date
        },
        {
            name: t('common.amount'),
            selector: 'amount',
            width: '180px',
            sortable: true,
            cell: row => row.amount
        },
        {
            name: "",
            center: true,
            width: '150px',
            cell: row => (buttonForColumns(row))
        }
    ]

    const buttonForColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.delete')}>
                    <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.idProcedure, row.procedureDocumentId)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    return (
        <div>
            {props.rigths.length
                ?
                <Container className={classes.generalBorder}>
                    <Backdrop className={classes.backdrop} open={openBackdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <br />
                    <Grid container direction="row" justify="space-between" alignItems="center" >
                        <Grid item xs={5}>
                            <FormControl fullWidth={true}>
                                <TextField
                                    label={t('common.type')}
                                    value={t('common.rigths')}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={1}> <br /> </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth={true}>
                                <InputLabel>{t('collateralDetails.rigthsProcedure')}</InputLabel>
                                <Select
                                    fullWidth
                                    name="ProcedureID"
                                    value={values.ProcedureID}
                                    onChange={handleInputChange}
                                >
                                    <MenuItem value="">
                                        <em>Ninguno</em>
                                    </MenuItem>
                                    {
                                        props.rigths.map((item, index) => (
                                            <MenuItem key={index} value={item.procedureID}>{item.procedureDescription}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <br />
                    <Grid container direction="row" justify="space-between" alignItems="center" >
                        <Grid item xs={5}>
                            <FormControl fullWidth={true}>
                                <Typography variant="body2">{t('common.amount')}</Typography>
                                <Input
                                    type="number"
                                    min={0}
                                    error={values.Amount < 0}
                                    name="Amount"
                                    value={values.Amount}
                                    onChange={handleInputChange}
                                    startAdornment={"$"}
                                    inputProps={{ pattern: "[0-9]*" }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={1}> <br /> </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth >
                                <Typography variant="body2">{t('collateralDetails.multipleFile')}</Typography>
                                <Input
                                    fullWidth
                                    type="file"
                                    name="pdf"
                                    className="filePDF"
                                    onChange={checkFileType}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}><br /></Grid>

                    <Grid item xs={12} className={classes.buttonAlign}>
                        <Button type="button" className={classes.generalBorder} variant="outlined" onClick={handleSubmit} > {t('common.save')} </Button>
                    </Grid>

                    <Grid item xs={12}><br /></Grid>
                    <Divider />
                    <Grid item xs={12}><br /></Grid>

                    <DataTable
                        noHeader
                        columns={columns}
                        customStyles={customStyleSecondary}
                        data={props.rigthsPerOrder}
                        highlightOnHover
                        defaultSortField="date"
                        dense
                        responsive
                        striped
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                    {
                        props.rigthsPerOrder && props.rigthsPerOrder.length < 1 && (
                            <Grid container item xs={12}><br /></Grid>
                        )
                    }
                </Container>
                :
                <CircularProgress color="inherit" />}
        </div>
    )
}

const mapStateToProps = state => ({
    rigths: state.CollateralReducer.rigths,
    rigthsPerOrder: state.CollateralReducer.rigthsPerOrder,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(CollateralStyles)(Rigths))